import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { GoogleMapUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import CoreMap from '@bd/bdui-coremap';
import { BtnAnimationSheen } from '../../helpers/UIElements';

import { colors } from '../../styles';
import AccordionToggle from '../../components/AccordionToggle';

const styles = css`
  @media(min-width: 992px) {
    padding: 50px 20px;
  }
  position: relative;
  .SmothLink_wrapper {
    @media(min-width: 768px) {
      padding: 50px 0;
      position: absolute;
      top: -70px;
      left: 0;
    }
  }
  .Map_wrapper{
    height: 250px;
    width: 100%;
    background-color: #c1c1c1;
    padding:0;
    @media(min-width: 992px){
      height: 500px;
    }
  }
  .Directions_wrapper{
    padding: 15px;
    @media(min-width:992px){
      padding: 0 50px;
    }
  }
  .CommunityDirections_btn {
    max-width: 145px;
    @media(min-width: 992px) {
      max-width: 199px;
    }
  }
  .CommunityDirections_btnHref {
    color: #FFF;
    &:hover {
      color: ${colors.whiteDarker};
    }
  }
  .CommunityDirections_directions {
    font-weight: 300;
    font-size: 15px;
    color: ${colors.color3};
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 40px;
    @media(min-width: 992px) {
      font-size: 17px;
      color: ${colors.text};
      line-height: 30px;
      margin-bottom: 50px;
    }
  }
`;

function CommunityDirections({ community }) {
  return (
    <div className={styles}>
      <AccordionToggle
        openOnId="directions"
        button={({ contentVisible }) => (
          <div className="">
            <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Map & Directions</h3>
          </div>
        )}
      >
        <div className="container">
          <div className="d-flex flex-lg-row flex-column container-fluid">
            <div className="Map_wrapper col-12 col-lg-6">
              <CoreMap
                pin={{
                  iconUrl: '/images/icons/map-pin.svg',
                  iconSize: [32, 46],
                  iconAnchor: [16, 46],
                }}
                className={css`
                  position: relative;
                  padding-bottom: 0;
                  width: 100%;
                  height:100%;
                  z-index: 0;

                  background-color: ${colors.color3};
                  @media(min-width:992px){
                    padding-bottom: 56.25%;
                  }
                  .leaflet-container {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                  }
                `}
                markers={[community]}
              />
            </div>
            <div className="Directions_wrapper col-12 col-lg-6">
              {
                get(community, 'directions', get(community, 'directions')) &&
                <div dangerouslySetInnerHTML={SanitizeHtml(get(community, 'directions'))} className="CommunityDirections_directions" />
              }
              <BtnAnimationSheen className="Btn_default CommunityDirections_btn">
                <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer" className="CommunityDirections_btnHref">
                  On Google
                </a>
              </BtnAnimationSheen>
            </div>
          </div>
        </div>
      </AccordionToggle>
    </div>
  );
}

CommunityDirections.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityDirections;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityDirections.js